import { useMemo } from "react";
import dayjs from "dayjs";
import { ChartDataPoint } from "../../../components/dashboard/ChartSection";

interface ReportItem {
  date?: string;
  week?: number;
  month?: number;
  year?: number;
  total_hour?: number;
  total_spent?: number;
}

interface UseChartDataParams {
  data?: { list?: ReportItem[] };
  period: string;
  valueKey: "total_hour" | "total_spent";
}

export const useChartData = ({
  data,
  period,
  valueKey,
}: UseChartDataParams): ChartDataPoint[] => {
  return useMemo(() => {
    const newData: ChartDataPoint[] = [];
    const reportList = data?.list || [];

    if (reportList.length === 0) {
      return newData;
    }

    if (period === "weekly") {
      reportList.forEach((item) => {
        newData.push({
          name: `W${item.week}`,
          total: Number(item[valueKey] || 0),
          week: `${dayjs()
            .set("month", (item.month || 1) - 1)
            .set("year", item.year || dayjs().year())
            .format("MMM YYYY")}`,
        });
      });
    } else if (period === "monthly") {
      reportList.forEach((item) => {
        newData.push({
          name: `${dayjs()
            .set("month", (item.month || 1) - 1)
            .format("MMM")}`,
          total: Number(item[valueKey] || 0),
          week: `${item.year || dayjs().year()}`,
        });
      });
    } else {
      // daily
      reportList.forEach((item) => {
        if (item.date) {
          newData.push({
            name: dayjs(item.date).date().toString(),
            total: Number(item[valueKey] || 0),
            week: `W${item.week} - ${dayjs(item.date).format("MMM YYYY")}`,
          });
        }
      });
    }

    return newData;
  }, [data, period, valueKey]);
};
